import { render, staticRenderFns } from "./cc-product-stock-informations.vue?vue&type=template&id=d0ec8fe2&"
import script from "./cc-product-stock-informations.ts?vue&type=script&lang=js&"
export * from "./cc-product-stock-informations.ts?vue&type=script&lang=js&"
import style0 from "./cc-product-stock-informations.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports